import { Directive, HostListener, Input } from '@angular/core';
import { NewFeatureDotService } from '../../services/new-feature-dot.service';

@Directive({
  selector: '[appNewFeature]',
  standalone: true,
})
export class NewFeatureDirective {
  @Input() appNewFeature: string;
  @HostListener('click', ['$event']) onClick() {
    this.service.markFeatureAsSeen(this.appNewFeature);
  }
  constructor(private service: NewFeatureDotService) {}
}
